import { Body, Button, Heading, Icon } from 'copilot-design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ModalWrapper } from 'src/legacy/components/Modals';

interface Props {
  open: boolean;
  title: string;
  onViewPlan: () => void;
  message: string;
}
export const ExpirePlanAlertDialog: React.FC<Props> = ({
  onViewPlan,
  open,
  title,
  message,
}) => {
  const { t } = useTranslation();

  const handleBookCall = () => {
    window.open(
      'https://copilotplatforms.chilipiper.com/concierge-router/link/trial-end',
      '_blank',
    );
  };
  return (
    <ModalWrapper
      closeButton={false}
      hasBackdrop
      hideDividers
      modalType="warning"
      positiveAction
      noCancelButton
      denseContent
      width={632}
      open={open}
      footerLeftButtonLabel="Switch workspace"
    >
      <div className="px-9 pt-6">
        <Heading className="text-[18px] pb-3">{title}</Heading>
        <Body className="text-gray-small pb-[22px]">{message}</Body>
        <div className="flex gap-5">
          <div className="bg-[#FBFBFB] border border-solid border-non-hover-border rounded-[14px] w-[268px] py-6 px-5 flex flex-col gap-4">
            <div className="flex justify-center items-center bg-white rounded-[10px] w-12 h-12 border border-solid border-non-hover-border">
              <Icon name="Billing" icon="Billing" className=" w-6 h-6" />
            </div>
            <Heading className="text-[15px] text-[#0A0A0A] leading-6">
              {t(
                ($) =>
                  $.page_plans.plan_alert_modal.trial_expired.pick_plan_title,
              )}
            </Heading>
            <Body className=" text-[#4A5565] leading-6">
              {t(
                ($) =>
                  $.page_plans.plan_alert_modal.trial_expired.pick_plan_body,
              )}
            </Body>
            <div>
              <Button
                label={t(
                  ($) =>
                    $.page_plans.plan_alert_modal.trial_expired
                      .pick_plan_button,
                )}
                variant="text"
                className="p-0"
                onClick={onViewPlan}
                suffixIcon="ArrowRight"
              />
            </div>
          </div>
          <div className="bg-[#FBFBFB] border border-solid border-non-hover-border rounded-[14px] w-[268px] py-6 px-5 flex flex-col gap-4">
            <div className="flex justify-center items-center bg-white rounded-[10px] w-12 h-12 border border-solid border-non-hover-border">
              <Icon name="Billing" icon="Message" className=" w-6 h-6" />
            </div>
            <Heading className="text-[15px] text-[#0A0A0A] leading-6">
              {t(
                ($) =>
                  $.page_plans.plan_alert_modal.trial_expired.meet_sales_title,
              )}
            </Heading>
            <Body className=" text-[#4A5565] leading-6">
              {t(
                ($) =>
                  $.page_plans.plan_alert_modal.trial_expired.meet_sales_body,
              )}
            </Body>
            <div>
              <Button
                label={t(
                  ($) =>
                    $.page_plans.plan_alert_modal.trial_expired
                      .meet_sales_button,
                )}
                variant="text"
                className="p-0"
                onClick={handleBookCall}
                suffixIcon="ArrowRight"
              />
            </div>
          </div>
        </div>
        <div className="border-b border-non-hover-border border-solid border-t-0 border-x-0 pt-[22px] pb-[6px]" />
      </div>
    </ModalWrapper>
  );
};
